"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BusinessSolutionCardParser = void 0;
var _services = require("../../../services");
var _constants = require("../../constants");
class BusinessSolutionCardParser {
  constructor(businessSolution, recommendationCharacteristics) {
    this.businessSolution = void 0;
    this.recommendationCharacteristics = void 0;
    this.businessSolution = businessSolution;
    this.recommendationCharacteristics = recommendationCharacteristics;
  }
  get EntelCardHeaderProps() {
    const mainPriceAfterDiscount = Object.keys(this.getPriceByPriceType('recurring-total1')).length > 1 ? this.getPriceByPriceType('recurring-total1') : this.getPriceByPriceType('recurring');
    const rightStackMainTextLarge = `${_services.Services.locale.formatPrice(mainPriceAfterDiscount.priceValue)}`;
    const rightStackMainTextNormal = `${_services.Services.locale.localeString('Recommendation.PaidPerUser')}`;
    const rightStackBottomTextNormal = _services.Services.locale.localeString('Recommendation.AutomaticCharge');
    const mainText = this.businessSolution.productName.split('+')[0];
    return {
      leftStack: {
        topText: _services.Services.locale.localeString('Recommendation.PlanName'),
        mainText: mainText
      },
      rightStack: {
        show5g: false,
        mainText: {
          large: rightStackMainTextLarge,
          normal: rightStackMainTextNormal,
          small: rightStackBottomTextNormal,
          spacing: true,
          normalMaxWidth: '140px'
        }
      }
    };
  }
  get EntelCardBodyProps() {
    const groupedData = this.groupByCharacteristic(this.businessSolution.selectedVariant.characteristics);
    const characteristics = this.recommendationCharacteristics.map(recommendation => {
      if (groupedData[recommendation.key]) {
        return {
          icon: recommendation.icon,
          state: 'error',
          text: recommendation.key,
          description: groupedData[recommendation.key] || []
        };
      }
    }).filter(Boolean);
    return {
      characteristics: characteristics
    };
  }
  getPriceByPriceType(priceType) {
    return this.businessSolution.selectedVariant.price.find(price => {
      return price.priceType === priceType;
    }) || {};
  }
  groupByCharacteristic(characteristics) {
    return characteristics.reduce((acc, obj) => {
      if (!(obj !== null && obj !== void 0 && obj.description) || _constants.COMPARISON_HIDDEN_VALUES.includes(obj === null || obj === void 0 ? void 0 : obj.valueText)) return acc;
      const group = obj.characteristicRelationship.find(el => el.relationshipType === 'group').id;
      if (!acc[group]) {
        acc[group] = [];
      }
      acc[group].push(obj.description);
      return acc;
    }, {});
  }
}
exports.BusinessSolutionCardParser = BusinessSolutionCardParser;